module.exports = __webpack_public_path__ + "media/icons/task-tick-5d92a98f.png";